import { MAX_WIDTH } from 'constants/maxWidth'
import React, { useMemo } from 'react'
import { StyleSheet } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

import { Box } from 'widgets/Box'

import { useFocusMode } from 'contexts/FocusModeContext'
import { useTheme } from 'contexts/ThemeContext'

import { CreatePostButton } from './CreatePostButton'
import { CustomTabBarIcon } from './CustomTabBarIcon'

export const CustomTabBar = (props: any) => {
  const insets = useSafeAreaInsets()
  const theme = useTheme()
  const { state, descriptors, navigation } = props

  const styles = StyleSheet.create({
    container: {
      paddingBottom: insets.bottom > 0 ? insets.bottom : theme.spacing.sm,
      paddingTop: theme.spacing.xs,
    },
  })

  const focusMode = useFocusMode()
  const isFocusMode = useMemo(() => focusMode.group !== undefined, [focusMode.group])
  const firstHalfIcons = [state.routes[0]]
  const lastHalfIcons = [state.routes[2]]

  return (
    <Box
      shadow='sm'
      justifyContent='center'
      align='center'
      backgroundColor={isFocusMode ? 'v2black' : 'white'}
      style={styles.container}
    >
      <Box flexDirection='row' width='100%' maxWidth={MAX_WIDTH}>
        {firstHalfIcons.map((route: any, index: number) => (
          <CustomTabBarIcon
            key={route.name}
            descriptors={descriptors}
            navigation={navigation}
            state={state}
            route={route}
            index={index}
          />
        ))}

        <CreatePostButton />

        {/* Index + 1 is necessary since we had two routes before the profile/Group route. */}
        {lastHalfIcons.map((route: any, index: number) => (
          <CustomTabBarIcon
            key={route.name}
            descriptors={descriptors}
            navigation={navigation}
            state={state}
            route={route}
            index={index + 1}
          />
        ))}
      </Box>
    </Box>
  )
}
